import { useGame, useS } from '../store/game';
import { Seg } from '../components/ui';
import { CF, CFGN, DIFFN } from '../content/settings';

export function Settings({ close }: { close: () => void }) {
  const S = useS(); const { dispatch } = useGame(); const c = CF();
  return (
    <section className="screen">
      <div><span className="label">Spieleinstellungen</span><h2>Schwierigkeit und Einflüsse</h2></div>
      <p>Der Schwierigkeitsgrad legt fest, wie oft und wie stark Krisen, Gerichte, Verbände und Partei eingreifen. Darunter könnt ihr einzelne Einflüsse an- oder abschalten. Änderungen gelten sofort, auch im laufenden Spiel.</p>
      <div className="diffs">{Object.keys(DIFFN).map((k) => (
        <button type="button" key={k} className="tcard" aria-pressed={c.diff === k} onClick={() => dispatch('setDiff', k)}><b>{DIFFN[k][0]}</b><span className="sub">{DIFFN[k][1]}</span></button>
      ))}</div>
      <div className="cfgs">{Object.keys(CFGN).map((k) => (
        <div className="cfg" key={k}><div className="mi"><b>{CFGN[k][0]}</b><span className="sub">{CFGN[k][1]}</span></div>
          <Seg value={c[k] ? 1 : 0} options={[[1, 'An'], [0, 'Aus']]} onChange={(v) => dispatch('setCfg', k, v === 1)} /></div>
      ))}</div>
      <div className="actions"><button type="button" className="yes" onClick={close}>{S.phase === 'program' ? 'Zurück zum Wahlprogramm' : 'Zurück zum Spiel'}</button></div>
    </section>
  );
}
